import "./Icons.scss";

import CloseImg from "../../assets/close-icon.png";
import CreateImg from "../../assets/create-icon.png";
import DeleteImg from "../../assets/delete-icon.png";
import HelpImg from "../../assets/help-icon.png";
import UpdateImg from "../../assets/update-icon.png";
import SortAscImg from "../../assets/sort-asc-icon.png";
import SortDescImg from "../../assets/sort-desc-icon.png";

interface Props {
  className?: string;
  onClick?: any;
}

const Icon = ({ className, onClick, iconImg }: any) => {
  return (
    <img
      className={`icons ${className ? className : ''}`}
      alt="Update"
      src={iconImg}
      onClick={onClick ? onClick : () => {}}
    />
  );
};

export const IconClose = ({ className, onClick }: Props) => (
  <Icon iconImg={CloseImg} className={className} onClick={onClick} />
);

export const IconCreate = ({ className, onClick }: Props) => (
  <Icon iconImg={CreateImg} className={className} onClick={onClick} />
);

export const IconDelete = ({ className, onClick }: Props) => (
  <Icon iconImg={DeleteImg} className={className} onClick={onClick} />
);

export const IconHelp = ({ className, onClick }: Props) => (
  <Icon iconImg={HelpImg} className={className} onClick={onClick} />
);

export const IconUpdate = ({ className, onClick }: Props) => (
  <Icon iconImg={UpdateImg} className={className} onClick={onClick} />
);

export const IconSortAsc = ({ className, onClick }: Props) => (
  <Icon iconImg={SortAscImg} className={className} onClick={onClick} />
);

export const IconSortDesc = ({ className, onClick }: Props) => (
  <Icon iconImg={SortDescImg} className={className} onClick={onClick} />
);
